import styled, { css } from "styled-components";

export const Selector = styled.div`
  display: flex;
  flex-direction: row;
  white-space: nowrap;
  scroll-snap-align: center;
  position: relative;
  padding-left: 48px;

  ${({ isActivated }) =>
    isActivated && css`
      ::before {
        content: "";
        position: absolute;
        transform: translate(0, -50%);
        top: 50%;
        left: 0;
        width: 0;
        height: 0;
        border-top: 12.5px solid transparent;
        border-bottom: 12.5px solid transparent;
        border-left: 15px solid white;
      }
    `
  }

  @media (max-width: 768px) {
    padding: 0;
    &::before {
      content: none;
    }
  }
`;

export const Numerator = styled.div`
  display: flex;
  place-content: center;
  place-items: center;

  border-radius: 50%;

  height: 30px;
  width: 30px;
  padding-top: 6px;

  color: white;
  font-weight: 400;

  border: 1px solid white;

  margin-right: 12px;

  ${({ isActivated, theme }) =>
    isActivated &&
    css`
      font-weight: 700;
      border-width: 2px;
    `
  }

  ${({ brokeState, theme }) =>
    brokeState &&
    css`
      background-color: ${theme.colors.darkYellow};
      border-color: ${theme.colors.darkYellow};
      color: #fff;
      padding-top: 0;
    `
  }

  ${({ isAccept, theme }) =>
    isAccept &&
    css`
      background-color: ${theme.colors.darkGreen};
      border-color: ${theme.colors.darkGreen};
      padding-top: 0;
    `
  }

  ${({ errorState, theme }) =>
    errorState &&
    css`
      background-color: ${theme.colors.red};
      border-color: ${theme.colors.red};
      color: #fff;
      padding-top: 0;
    `
  }

  svg {
    margin-bottom: 0 !important;
    height: 18px;
    width: 18px;
    font-size: 1.125rem;
  }
`;

export const Label = styled.span`
  place-self: center;

  color: white;
  font-weight: 400;

  ${({ isActivated, theme }) =>
    isActivated &&
    css`
      font-weight: 700;
    `}

  /* ${({ isAccept, theme }) =>
    isAccept &&
    css`
      font-weight: 700;
    `
  } */
`;

export const Container = styled.div`
  font-size: 0.9375rem;

  display: flex;
  flex-direction: column;
  gap: 24px;

  scroll-snap-type: x mandatory;

  @media (max-width: 768px) {
    flex-direction: row;
    overflow-y: hidden;
    margin-top: 30px;
    margin-bottom: 12px;
    ${Selector} {
      margin-right: 18px;
    }

    ${Selector}:first-child {
      margin-left: 100px;
    }
  }

  &::-webkit-scrollbar {
    opacity: 0;
  }
`;
